export const buttonSemanticTokens = {
  bg: {
    solid: { value: "{colors.green.500}" },
    solidHover: { value: "{colors.green.600}" },
    solidActive: { value: "{colors.green.700}" },

    ghost: { value: "{colors.primary.white}" },
    ghostHover: { value: "{colors.green.100}" },
    ghostActive: { value: "{colors.green.500}" },

    subtle: { value: "{colors.green.500}" },
  },

  text: {
    solid: { value: "{colors.primary.white}" },
    solidHover: { value: "{colors.primary.white}" },
    solidActive: { value: "{colors.primary.white}" },
    solidDisabled: { value: "{colors.gray.500}" },

    ghost: { value: "{colors.primary.black}" },
    ghostHover: { value: "{colors.primary.black}" },
    ghostActive: { value: "{colors.primary.white}" },

    subtle: { value: "{colors.primary.white}" },

    outline: { value: "{colors.green.500}" },
  },

  fontSizes: {
    sm: { value: "{fontSizes.sm}" },
    md: { value: "{fontSizes.md}" },
    lg: { value: "{fontSizes.lg}" },
  },

  radii: {
    solid: { value: "{radii.2xl}" },
  },

  fontWeights: {
    normal: { value: "{fontWeights.medium}" },
    bold: { value: "{fontWeights.bold}" },
  },
};
